import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromEventTicketPurchases from './+state/event-ticket-purchases.reducer'
import { EventTicketPurchasesEffects } from './+state/event-ticket-purchases.effects'
import { EventTicketPurchasesFacade } from './+state/event-ticket-purchases.facade'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromEventTicketPurchases.EVENT_TICKET_PURCHASES_FEATURE_KEY,
      fromEventTicketPurchases.reducer,
    ),
    EffectsModule.forFeature([EventTicketPurchasesEffects]),
  ],
  providers: [EventTicketPurchasesFacade],
})
export class GbDashboardEventTicketsDataAccessEventTicketPurchasesModule {}
